
import { AssetsUserDetailsEntityDecorator } from './assets-user-details.decorator';
import { AssetsUserDetails } from './assets-user-details.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class AssetsUserDetailsTypeInfoBase implements CrudTypeInfo<AssetsUserDetails, string> {
  name = 'Assets User Details';
  entityDecorator = new AssetsUserDetailsEntityDecorator();
  
  createAuthorities = ['WRITE_ASSETS_USER_DETAILS'];
  editAuthorities = ['WRITE_ASSETS_USER_DETAILS'];
  deleteAuthorities = ['WRITE_ASSETS_USER_DETAILS'];
  viewAuthorities = ['READ_ASSETS_USER_DETAILS'];
  
  searchRouteBase = ['/assetsuserdetails/search'];
  createRouteBase = ['/assetsuserdetails/create'];
  editRouteBase = ['/assetsuserdetails/edit'];
  viewRouteBase = ['/assetsuserdetails/view'];
  
  description(item: AssetsUserDetails): string {
    return '' +  item.user;
  }
}



